import { differenceInSeconds, format, formatDistanceToNow } from 'date-fns';

/**
 * Formats time remaining until a date
 * - If < 24 hours: shows countdown in HH:MM:SS format (e.g., "05:46:02")
 * - If >= 24 hours: shows relative time (e.g., "2 days")
 * - If in the past: shows formatted date
 */
export const formatTimeRemaining = (targetDate: Date | string): string => {
  const target = typeof targetDate === 'string' ? new Date(targetDate) : targetDate;
  const now = new Date();

  // If date is in the past, show formatted date
  if (target < now) {
    return format(target, 'MMM d, h:mm a');
  }

  const totalSeconds = differenceInSeconds(target, now);

  if (totalSeconds <= 0) {
    return 'Live';
  }

  const hours = Math.floor(totalSeconds / (60 * 60));
  const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
  const seconds = totalSeconds % 60;

  // If less than 24 hours, show countdown in HH:MM:SS format
  if (hours < 24) {
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  // If 24 hours or more, show relative time (remove "in " prefix)
  const distance = formatDistanceToNow(target, { addSuffix: true });
  return distance.replace('in ', '');
};
